import Slider from "react-slick";

// import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import ".././Slick/Slick.css";

import { Box, Image, Center, Spinner } from "@chakra-ui/react";
// import ProHeading from "./Heading";

import React, { useEffect, useState } from "react";

const SlidingBox = () => {
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);

  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  useEffect(() => {
    const getdata = () => {
      setLoading(true);
      fetch(`https://json-server-1mg.onrender.com/SlidingBox_sec1`)
        .then((res) => res.json())
        .then((data) => {
          setAllData(data);
          setLoading(false);
        });
    };

    getdata();
  }, []);

  return (
    <>
      {/* <ProHeading /> */}
      {loading && (
        <Box>
          {" "}
          <Center>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              marginTop="20%"
              size="xl"
            />
          </Center>{" "}
        </Box>
      )}

      <Slider {...settings}>
        {allData.map((elem) => (
          <Box key={elem.id}>
            <Box>
              <Image
                src={elem.img}
                alt={elem.alt}
                style={{ height: "190px" }}
              />
            </Box>
          </Box>
        ))}
      </Slider>
      <Box my="7"></Box>
    </>
  );
};

export default SlidingBox;
